import type { IBrandLinearGradientColorFormula } from '../types';

/** 返回 "linear-gradient(90deg, #ffffff 0%,#ff6261 100%)" 或 "#ffffff" */
export const getColorCSSText = (color: string | IBrandLinearGradientColorFormula): string => {
    if (typeof color === 'object') {
        return `linear-gradient(${color.angle}deg, ${color.colors
            .map((c) => `${c.color} ${c.value * 100}%`)
            .join(', ')})`;
    }
    return color;
};

export const getColorFormulaFromCSSText = (color: string): IBrandLinearGradientColorFormula | string => {
    if (color.includes('linear-gradient')) {
        // 正则匹配
        const angle = color.match(/linear-gradient\((\d+)deg/)![1];
        const colors = color
            .split(',')
            .slice(1)
            .map((c) => {
                const [color, value] = c.trim().split(' ');
                return { value: parseFloat(value.trim()) / 100, color: color.trim() };
            });
        return {
            type: 0,
            angle: parseInt(angle),
            colors,
        };
    }
    return color;
};
